export default __webpack_public_path__ + "static/media/passport_front_res.399b448b.jpg";